//@ts-nocheck
import React from "react";
import { Props } from "./AboutUsSurveyStepController.web";
import {
  Typography,
  withStyles,
  createStyles,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import { surveyStyles, aboutUsStyle } from "./surveyStyles";
import TaxFillingComponent from "./SurveyTaxFilling.web";
import BusinessCompnent from "./BusinessDetail.web";
import AboutUsComponent from "./CfsClientDetail.web";
import AccountingComponent from "./CFSAccounting.web";
import FirmQuestions from "./layout/FirmQuestions.web";
import { screenForAboutUsStep } from "./firmQuestions";
import { CURRENT_SITUATION, getOptionOrderNo } from "./surveyOptions";
import QuestionCard from "./layout/QuestionCard.web";
import OptionList from "./layout/OptionList.web";
import StepFooter from "./layout/StepFooter.web";

export class AboutUsSurveyStep extends React.Component {
  constructor(props: Props) {
    super(props);
  }
  checkIfNumber = (e, setFieldValue) => {
    const regex = /\d+(\.\d\d?)?/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      let t = e.target.value;
      t =
        t.indexOf(".") >= 0
          ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
          : t;
      let nf = new Intl.NumberFormat("en-US");
      return nf.format(t?.replace(/,/g, "")) === "0"
        ? ""
        : nf.format(t?.replace(/,/g, ""));
    }
  };

  getStep3Content = (classes) => {
    const step1 = getOptionOrderNo(this.props.step1Selection);
    const taxPayerType = this.props.taxPayerType;
    console.log(step1, taxPayerType, "step1,taxPayerType");
    const callbackToPass = () => {
      const newStep = this.props.getStepno3byStep1AndStep2();
      if (newStep) {
        this.props.getQuestionAndOptionsByStepNo(newStep);
      }
    };

    const textFieldOnKeyPressHandler = (event) => {
      if (
        !(
          (event.charCode != 8 && event.charCode == 0) ||
          (event.charCode >= 48 && event.charCode <= 57)
        )
      ) {
        event.preventDefault();
      }
    };

    const textFieldOnChangeHandler = (event) => {
      this.props.setValueByDynamicName(
        "totalAnnualIncome",
        this.checkIfNumber(event)
      );
    };

    const gotoBackStepHandler = () => {
      this.props.setCurrentAboutUsStep(2, callbackToPass);
    };

    const handleNext = () => this.props.setCurrentAboutUsStep(4);
    if (
      step1 === CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "individual"
    ) {
      return (
        <TaxFillingComponent
          firmQuestions={this.props.firmQuestions}
          firmAnswers={this.props.firmAnswers}
          setFirmAnswer={this.props.setFirmAnswer}
          taxPayerType={this.props.taxPayerType}
          {...this.props}
          gotoBackStep={gotoBackStepHandler}
          gotoNextStep={handleNext}
          titleMessage={"Tell us about your most recent tax filling"}
        />
      );
    } else if (
      step1 !== CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "individual"
    ) {
      return (
        <>
          <QuestionCard
            title="What is your Annual Household Income?"
            hint="In order to show you the right feature options, we need to know your annual income"
          >
            <TextField
              color="primary"
              variant="outlined"
              fullWidth
              id="totalAnnualIncome"
              value={this.props.totalAnnualIncome}
              onKeyPress={textFieldOnKeyPressHandler}
              onChange={textFieldOnChangeHandler}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography className={classes.dollarSign}>$</Typography>
                  </InputAdornment>
                ),
                inputProps: { min: 1, pattern: "[1-9]d*" },
              }}
            />
            <Typography className={classes.includeText}>
              Include all sources, wages, investments, part-time gigs for you
              and anyone in your household.
            </Typography>
          </QuestionCard>
          <FirmQuestions
            screen="annual_income"
            taxPayerType={this.props.taxPayerType}
            questions={this.props.firmQuestions}
            answers={this.props.firmAnswers}
            onChange={this.props.setFirmAnswer}
          />
          <StepFooter
            onBack={gotoBackStepHandler}
            onNext={() => this.props.setCurrentAboutUsStep(4, undefined)}
            nextDisabled={!this.props.totalAnnualIncome}
          />
        </>
      );
    } else if (
      step1 === CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "business"
    ) {
      return (
        <BusinessCompnent
          firmQuestions={this.props.firmQuestions}
          firmAnswers={this.props.firmAnswers}
          setFirmAnswer={this.props.setFirmAnswer}
          taxPayerType={this.props.taxPayerType}
          {...this.props}
          gotoBackStep={gotoBackStepHandler}
          gotoNextStep={this.props.setCurrentAboutUsStep.bind(
            this,
            4,
            undefined
          )}
          titleMessage={"Provide any updates about your business."}
        />
      );
    } else if (
      step1 !== CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "business"
    ) {
      return (
        <BusinessCompnent
          firmQuestions={this.props.firmQuestions}
          firmAnswers={this.props.firmAnswers}
          setFirmAnswer={this.props.setFirmAnswer}
          taxPayerType={this.props.taxPayerType}
          {...this.props}
          gotoBackStep={gotoBackStepHandler}
          gotoNextStep={this.props.setCurrentAboutUsStep.bind(
            this,
            4,
            undefined
          )}
          titleMessage={"Tell us a little bit about your business."}
        />
      );
    }
  };
  getStep4Content = (classes) => {
    const step1 = getOptionOrderNo(this.props.step1Selection);
    const taxPayerType = this.props.taxPayerType;
    if (
      step1 === CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "individual"
    ) {
      return (
        <AboutUsComponent
          {...this.props}
          gotoBackStep={this.props.setCurrentAboutUsStep.bind(
            this,
            3,
            undefined
          )}
          gotoNextStep={this.props.handleNext.bind(this)}
        />
      );
    } else if (
      step1 !== CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "individual"
    ) {
      const gotoBackStep4 = () => {
        this.props.setCurrentAboutUsStep(3, () => {
          const newStep = this.props.getStepno3byStep1AndStep2();
          if (newStep) {
            this.props.getQuestionAndOptionsByStepNo(newStep);
          }
        });
      };
      return (
        <TaxFillingComponent
          firmQuestions={this.props.firmQuestions}
          firmAnswers={this.props.firmAnswers}
          setFirmAnswer={this.props.setFirmAnswer}
          taxPayerType={this.props.taxPayerType}
          {...this.props}
          gotoBackStep={gotoBackStep4}
          gotoNextStep={this.props.setCurrentAboutUsStep.bind(
            this,
            5,
            undefined
          )}
          titleMessage={"Tell us about your most recent tax filing"}
        />
      );
    } else if (
      (step1 === CURRENT_SITUATION.EXISTING_CLIENT &&
        taxPayerType === "business") ||
      (step1 !== CURRENT_SITUATION.EXISTING_CLIENT &&
        taxPayerType === "business")
    ) {
      return (
        <AccountingComponent
          firmQuestions={this.props.firmQuestions}
          firmAnswers={this.props.firmAnswers}
          setFirmAnswer={this.props.setFirmAnswer}
          taxPayerType={this.props.taxPayerType}
          {...this.props}
          gotoBackStep={this.props.setCurrentAboutUsStep.bind(
            this,
            3,
            undefined
          )}
          gotoNextStep={this.props.setCurrentAboutUsStep.bind(
            this,
            5,
            undefined
          )}
          titleMessage={"Tell us about your most recent tax filing"}
        />
      );
    }
  };
  getStep5Content = (classes) => {
    const step1 = getOptionOrderNo(this.props.step1Selection);
    const taxPayerType = this.props.taxPayerType;
    if (
      step1 !== CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "individual"
    ) {
      return (
        <AboutUsComponent
          {...this.props}
          gotoBackStep={this.props.setCurrentAboutUsStep.bind(
            this,
            4,
            undefined
          )}
          gotoNextStep={this.props.handleNext.bind(this)}
        />
      );
    } else if (
      step1 === CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "business"
    ) {
      return (
        <TaxFillingComponent
          firmQuestions={this.props.firmQuestions}
          firmAnswers={this.props.firmAnswers}
          setFirmAnswer={this.props.setFirmAnswer}
          taxPayerType={this.props.taxPayerType}
          {...this.props}
          gotoBackStep={this.props.setCurrentAboutUsStep.bind(
            this,
            4,
            undefined
          )}
          gotoNextStep={this.props.setCurrentAboutUsStep.bind(
            this,
            6,
            undefined
          )}
          titleMessage={
            "Provide us with any updates about your next tax filing"
          }
        />
      );
    } else if (
      step1 !== CURRENT_SITUATION.EXISTING_CLIENT &&
      taxPayerType === "business"
    ) {
      return (
        <TaxFillingComponent
          firmQuestions={this.props.firmQuestions}
          firmAnswers={this.props.firmAnswers}
          setFirmAnswer={this.props.setFirmAnswer}
          taxPayerType={this.props.taxPayerType}
          {...this.props}
          gotoBackStep={this.props.setCurrentAboutUsStep.bind(
            this,
            4,
            undefined
          )}
          gotoNextStep={this.props.setCurrentAboutUsStep.bind(
            this,
            6,
            undefined
          )}
          titleMessage={"Tell us about your most recent tax filing"}
        />
      );
    }
  };
  getStep6Content = (classes) => {
    const step1 = getOptionOrderNo(this.props.step1Selection);
    const taxPayerType = this.props.taxPayerType;
    if (
      (step1 === CURRENT_SITUATION.EXISTING_CLIENT &&
        taxPayerType === "business") ||
      (step1 !== CURRENT_SITUATION.EXISTING_CLIENT &&
        taxPayerType === "business")
    ) {
      return (
        <AboutUsComponent
          {...this.props}
          gotoBackStep={this.props.setCurrentAboutUsStep.bind(
            this,
            5,
            undefined
          )}
          gotoNextStep={this.props.handleNext.bind(this)}
        />
      );
    }
  };

  async componentDidMount() {
    const step = this.props.currentAboutUsStep > 2 ? 5 : 1;
    this.props.getQuestionAndOptionsByStepNo(step);
  }

  handleStep1 = () => {
    this.props.setCurrentAboutUsStep(1, () => {
      this.props.getQuestionAndOptionsByStepNo(2);
    });
  };
  handleStep2 = (m) => {
    this.props.setCurrentAboutUsStep(2, () => {
      const newStep = this.props.getStepno3byStep1AndStep2();
      if (newStep) {
        this.props.getQuestionAndOptionsByStepNo(newStep);
      }
    });
  };
  handleStep3 = (m) => {
    this.props.setCurrentAboutUsStep(3);
  };
  handleStep2Back = () => {
    this.props.setCurrentAboutUsStep(0, () => {
      this.props.getQuestionAndOptionsByStepNo(1);
    });
  };
  handleStep3Back = () => {
    this.props.setCurrentAboutUsStep(1, () => {
      this.props.getQuestionAndOptionsByStepNo(2);
    });
  };

  render() {
    const options = this.props?.stepContent?.options?.data;
    const { currentAboutUsStep } = this.props;
    return (
      <>
        {currentAboutUsStep === 0 && (
          <>
            <QuestionCard
              title={this.props?.stepContent?.description}
              hint="Pick the one that best describes you"
            >
              <OptionList
                options={options}
                selected={this.props.step1Selection}
                onSelect={this.props.setStep1Selection}
                optionClassName="staticPakcageCard"
              />
            </QuestionCard>
            <StepFooter
              onBack={this.props.history.goBack}
              onNext={this.handleStep1}
              nextDisabled={!this.props.step1Selection}
            />
          </>
        )}
        {currentAboutUsStep === 1 && (
          <>
            <QuestionCard
              title={this.props?.stepContent?.description}
              hint="Choose the option that matches your situation best"
            >
              <OptionList
                options={options}
                selected={this.props.step2Selection}
                onSelect={this.props.setStep2Selection}
                optionClassName="staticPakcageCard"
              />
            </QuestionCard>
            <StepFooter
              onBack={this.handleStep2Back}
              onNext={this.handleStep2}
              nextDisabled={!this.props.step2Selection}
            />
          </>
        )}
        {currentAboutUsStep === 2 && (
          <>
            <QuestionCard
              title={this.props.getHeadingOfStep3(
                this.props.getStepno3byStep1AndStep2()
              )}
              hint="Select all that apply"
            >
              <OptionList
                options={options}
                selected={this.props.step3Selection}
                multiple
                onSelect={this.props.setStep3Selection}
                optionClassName="staticPakcageCard"
              />
            </QuestionCard>
            {screenForAboutUsStep(this.props.getStepno3byStep1AndStep2()) && (
              <FirmQuestions
                screen={
                  screenForAboutUsStep(this.props.getStepno3byStep1AndStep2()) || ""
                }
                taxPayerType={this.props.taxPayerType}
                questions={this.props.firmQuestions}
                answers={this.props.firmAnswers}
                onChange={this.props.setFirmAnswer}
              />
            )}
            <StepFooter
              onBack={this.handleStep3Back}
              onNext={this.handleStep3}
              nextDisabled={!this.props.step3Selection}
            />
          </>
        )}
        {currentAboutUsStep === 3 && this.getStep3Content(this.props.classes)}
        {currentAboutUsStep === 4 && this.getStep4Content(this.props.classes)}
        {currentAboutUsStep === 5 && this.getStep5Content(this.props.classes)}
        {currentAboutUsStep === 6 && this.getStep6Content(this.props.classes)}
      </>
    );
  }
}
const AboutUsSurveyStepWithRouter = withRouter(AboutUsSurveyStep);
const AboutUsSurveyStepAlertBox = withAlertBox(AboutUsSurveyStepWithRouter);
const AboutUsSurveyStepLoader = withLoader(AboutUsSurveyStepAlertBox);
const AboutUsSurveyStepToast = withToast(AboutUsSurveyStepLoader);
const AboutUsSurveyStepWithDialog = withDialog(AboutUsSurveyStepToast);

export default withStyles((theme) =>
  createStyles({
    ...surveyStyles(theme),
    ...aboutUsStyle(theme),
  })
)(withConfirmBox(AboutUsSurveyStepWithDialog));
